import { render, staticRenderFns } from "./ReposTable.vue?vue&type=template&id=0e3b826f&scoped=true&"
import script from "./ReposTable.vue?vue&type=script&lang=ts&"
export * from "./ReposTable.vue?vue&type=script&lang=ts&"
import style0 from "./ReposTable.vue?vue&type=style&index=0&id=0e3b826f&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3b826f",
  null
  
)

export default component.exports